import { render, staticRenderFns } from "./bindAccount.vue?vue&type=template&id=5372ce42&"
import script from "./bindAccount.vue?vue&type=script&lang=js&"
export * from "./bindAccount.vue?vue&type=script&lang=js&"
import style0 from "./bindAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports